import React from 'react'
import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import RepairTrackingView from '../views/RepairTrackingView'
import type { RepairTruckWithTruck } from '../views/RepairTrackingView'
import type { RepairTruckWorkStatus } from '@otw/models/logistics'

interface RepairTimelineDialogProps {
  open: boolean
  onClose: () => void
  item: RepairTruckWithTruck | null
  getRepairShopLabel: (item: RepairTruckWithTruck) => string
  getUserName?: (userId: string) => string
  onAddNote: (
    repairTruckId: string,
    payload: { note: string; visible_to_repair_users?: boolean }
  ) => Promise<void>
  onEditNote: (repairTruckId: string, noteIndex: number, note: string) => Promise<void>
  onSetNoteVisibleToRepairUsers: (
    repairTruckId: string,
    noteIndex: number,
    visible_to_repair_users: boolean
  ) => Promise<void>
  onDeleteNote: (repairTruckId: string, noteIndex: number) => Promise<void>
  onUpdateWorkStatus: (repairTruckId: string, work_status: RepairTruckWorkStatus) => Promise<void>
  onReviewEstimate: (
    repairTruckId: string,
    noteIndex: number,
    status: 'approved' | 'rejected'
  ) => Promise<void>
  onUpdatePaid: (repairTruckId: string, paid: boolean) => Promise<void>
  onUpdateBeingPainted: (repairTruckId: string, being_painted: boolean) => Promise<void>
  onToggleFlag: (repairTruckId: string, flagged: boolean) => Promise<void>
  isAddingNote?: boolean
  isEditingNote?: boolean
  isDeletingNote?: boolean
  isUpdatingWorkStatus?: boolean
  isReviewingEstimate?: boolean
  isUpdatingPaid?: boolean
  isUpdatingBeingPainted?: boolean
  isUpdatingFlag?: boolean
}

const RepairTimelineDialog: React.FC<RepairTimelineDialogProps> = ({
  open,
  onClose,
  item,
  getRepairShopLabel,
  getUserName,
  onAddNote,
  onEditNote,
  onSetNoteVisibleToRepairUsers,
  onDeleteNote,
  onUpdateWorkStatus,
  onReviewEstimate,
  onUpdatePaid,
  onUpdateBeingPainted,
  onToggleFlag,
  isAddingNote,
  isEditingNote,
  isDeletingNote,
  isUpdatingWorkStatus,
  isReviewingEstimate,
  isUpdatingPaid,
  isUpdatingBeingPainted,
  isUpdatingFlag,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Repair timeline</DialogTitle>
      <DialogContent>
        {item && (
          <RepairTrackingView
            items={[item]}
            getRepairShopLabel={getRepairShopLabel}
            getUserName={getUserName}
            onAddNote={onAddNote}
            onEditNote={onEditNote}
            onSetNoteVisibleToRepairUsers={onSetNoteVisibleToRepairUsers}
            onDeleteNote={onDeleteNote}
            onUpdateWorkStatus={onUpdateWorkStatus}
            onReviewEstimate={onReviewEstimate}
            onUpdatePaid={onUpdatePaid}
            onUpdateBeingPainted={onUpdateBeingPainted}
            onToggleFlag={onToggleFlag}
            isAddingNote={isAddingNote}
            isEditingNote={isEditingNote}
            isDeletingNote={isDeletingNote}
            isUpdatingWorkStatus={isUpdatingWorkStatus}
            isReviewingEstimate={isReviewingEstimate}
            isUpdatingPaid={isUpdatingPaid}
            isUpdatingBeingPainted={isUpdatingBeingPainted}
            isUpdatingFlag={isUpdatingFlag}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default RepairTimelineDialog
